import request from '../utils/request';

//获取个人信息
export function getUserDetail(data) {
  return request({
    url: '/user/getUserDetail',
    method: 'post',
    data
  })
}
//申请发票--true
export function doGenerateInvoice(data) {
  return request({
    url: '/invoice/doGenerateInvoiceNew.do',
    method: 'post',
    data
  });
}
//教师列表
export function findTeacherList(data) {
  return request({
    url: '/web/findTeacherList.html',
    method: 'post',
     data,
  })
}
//教师详情
export function getSysTeacherDetail(data) {
  return request({
    url: '/web/getSysTeacherDetail.html',
    method: 'post',
     data,
  })
}

//获取用户详情--true
export function getUser(data) {
  return request({
    url: '/userData/getUser.do',
    method: 'post',
    data
  });
}

//轮播详情
export function getPictureDetail(query) {
  return request({
    url: '/info/getPictureDetail.html',
    method: 'get',
     params: query,
  })
}
//获取用户证书列表
export function toCertList(data) {
  return request({
    url: '/userData/toCertList.do',
    method: 'post',
    data
  });
}


//获取证书详情
export function getCertDetail(data) {
  return request({
    url: '/userData/getCertDetail.do',
    method: 'post',
    data
  });
}

//证书申请页面接口
export function toApplyCert(data) {
  return request({
    url: '/userData/toApplyCert.do',
    method: 'post',
    data
  });
}


//证书批量申请页面接口
export function toApplyCertMore(data) {
  return request({
    url: '/userData/toApplyCertMore.do',
    method: 'post',
    data
  });
}


//验证申请证书请求接口
export function toGetCert(data) {
  return request({
    url: '/userData/toGetCert.do',
    method: 'post',
    data
  });
}

//申请证书请求接口
export function toGenExpress(data) {
  return request({
    url: '/userData/toGenExpress.do',
    method: 'post',
    data
  });
}

//验证申请证书请求接口（批量）
export function toGetCertBatch(data) {
  return request({
    url: '/userData/toGetCertBatch.do',
    method: 'post',
    data
  });
}

//取消自领接口
export function toCancelZL(data) {
  return request({
    url: '/userData/toCancelZL.do',
    method: 'post',
    data
  });
}

//取消代领接口
export function toCancelDL(data) {
  return request({
    url: '/userData/toCancelDL.do',
    method: 'post',
    data
  });
}

//请人代领接口
export function toPleaseLead(data) {
  return request({
    url: '/userData/toPleaseLead.do',
    method: 'post',
    data
  });
}

//代领接口
export function doPleaseLead(data) {
  return request({
    url: '/userData/doPleaseLead.do',
    method: 'post',
    data
  });
}

//订单详情
export function toOrderDetail(data) {
  return request({
    url: '/userData/toOrderDetail.do',
    method: 'post',
    data
  });
}



//删除订单
export function doDeleteOrder(data) {
  return request({
    url: '/userData/doDeleteOrder.do',
    method: 'post',
    data
  });
}



//修改手机号
export function doUpdateMobile(data) {
  return request({
    url: '/userData/doUpdateMobile.do',
    method: 'post',
    data,
  })
}
//修改密码
export function doUpdateUserPasswd(data) {
  return request({
    url: '/user/doUpdateUserPasswd.do',
    method: 'post',
    data,
  })
}
//获取用户地址列表
export function getUserAddressList(data) {
  return request({
    url: '/userData/getUserAddressList.do',
    method: 'post',
    data
  });
}

//新增地址
export function addUserAddress(data) {
  return request({
    url: '/userData/addUserAddress.do',
    method: 'post',
    data
  });
}

//在学进度
export function toMyClassList(data) {
  return request({
    url: '/learning/toMemberCenter.do',
    method: 'post',
    data
  });
}

//分类列表
export function getCodeByParent(data) {
  return request({
    url: '/userData/getMemberXL.do',
    method: 'post',
    data
  });
}


//获取职称
export function getTitleList(data) {
  return request({
    url: '/learning/getTitleList.do',
    method: 'post',
    data
  });
}

//修改用户资料
export function updateUser(data) {
  return request({
    url: '/userData/updateUser.do',
    method: 'post',
    data
  });
}

//获取验证码
export function sendDx2(data) {
  return request({
    url: '/web/sendDx2.do',
    method: 'post',
    data
  });
}

//修改手机下一步
export function checkCode(data) {
  return request({
    url: '/userData/checkCode.do',
    method: 'post',
    data
  });
}



//是否考试
export function checkUserQuiz(data) {
  return request({
    url: '/learning/checkUserQuiz.do',
    method: 'post',
    data
  });
}

//获取证书类型
export function toGetCertType(data) {
  return request({
    url: '/userData/toGetCertType.do',
    method: 'post',
    data
  });
}


//判断token是否可用
export function checkToken(data) {
  return request({
    url: '/user/checkToken.html',
    method: 'get',
    params:data
  });
}

//我的课程资源库
export function toMyZYKCourseList(data) {
  return request({
    url: '/learning/toMyZYKCourseList.do',
    method: 'post',
    data:data
  });
}

//应急
export function toMyZypxCourseList(data) {
  return request({
    url: '/learning/toYjglClassList.do',
    method: 'post',
    data:data
  });
}
//获取视频地址
export function toZYKStudy(data) {
  return request({
    url: '/learning/toZYKStudy.do',
    method: 'post',
    data:data
  });
}
//获取职业视频地址
export function toZypxStudy(query) {
  return request({
    url: '/learning/toPcStudy.do',
    method: 'get',
    params:query
  });
}
//获取视频目录
export function toZYKStudyMain(data) {
  return request({
    url: '/learning/toZYKStudyMain.do',
    method: 'post',
    data:data
  });
}
//获取z职业教育视频目录
export function toZypxStudyMain(data) {
  return request({
    url: '/learning/toPcMyCourseList.do',
    method: 'post',
    data
  });
}


//获取用户信息
export function getUserInfo(data) {
  return request({
    url: '/learning/getUserInfo.html',
    method: 'get',
    data
  });
}
//获取中经网视频
export function getVideoUrl(data) {
  return request({
    url: 'learning/toPcVideoUrl.do',
    method: 'post',
   data:data
  });
}

//获取人脸识别规则
export function getFaceConfig(data) {
  return request({
    url: 'user/getFaceConfig.do',
    method: 'get',
    params:data
  });
}
//截图
export function healthCertificate(data) {
  return request({
    url: 'userData/healthCertificate.html',
    method: 'post',
    data,
  })
}
//截图
export function studentCard(data) {
  return request({
    url: 'order/studentCard.html',
    method: 'post',
    data,
  })
}
//截图
export function certImage(data) {
  return request({
    url: 'userData/certImage.html',
    method: 'post',
    data,
  })
}
//对比照片
export function compareAndSavePhoto(data) {
  return request({
    url: 'user/compareAndSavePhoto.do',
    method: 'post',
    data
  });
}

//考试详情页

export function toExamUQDetailNew(data) {
  return request({
    url: '/user/toExamUQDetailNew',
    method: 'post',
    data
  });
}
//是否可以考试
export function findUQStateNew(data) {
  return request({
    url: 'userQuiz/findUQStateNew.do',
    method: 'post',
    data
  });
}

//参加模拟考试
export function toMockJoinExam(data) {
  return request({
    url: '/user/toMockJoinExam',
    method: 'post',
    data
  });
}


//获取题目
export function toJoinExam(data) {
  return request({
    url: 'userQuiz/toJoinExamNew.do',
    method: 'post',
    data
  })
}
//提交试卷
export function handInNew(data) {
  return request({
    url: '/user/handInNew.do',
    method: 'post',
    data
  })
}
//保存用户选择答案
export function handIn(data) {
  return request({
    url: 'userQuiz/handInZs.do',
    method: 'post',
    data
  })
}

//回显试卷
export function toPreview(data) {
  return request({
    url: 'user/toMockPreview',
    method: 'post',
    data
  })
}


//订单列表
export function toOrderList(data) {
  return request({
    url: '/order/toOrderList.do',
    method: 'post',
    data,
  })
}
//订单详情
export function getOrderDetail(data) {
  return request({
    url: '/order/getOrderDetail',
    method: 'post',
    data,
  })
}
//取消订单
export function doCancelOrder(data) {
  return request({
    url: '/userData/doCancelOrder.do',
    method: 'post',
    data,
  })
}
//开发票
export function toGenerateInvoice(data) {
  return request({
    url: '/invoice/toGenerateInvoice.do',
    method: 'post',
    data,
  })
}
//查看发票
export function queryInvoiceResult(data) {
  return request({
    url: '/invoice/queryInvoiceResult',
    method: 'post',
    data,
  })
}
//学习主页
export function getClassLearnInfo(data) {
  return request({
    url: '/learning/getClassLearnInfo',
    method: 'post',
    data,
  })
}
//章节信息
export function getResChapterList(data) {
  return request({
    url: '/learning/getResChapterList',
    method: 'post',
    data,
  })
}
//记录学时
export function updateDBTrack(data) {
  return request({
    url: '/learning/updateDBTrack.do',
    method: 'post',
    data,
    hideLoading: true  // 添加这个配置来跳过加载提示
  })
}
//页面进入总数据
export function toStudy(data) {
  return request({
    url: '/learning/toStudy.do',
    method: 'post',
    data,
  })
}

//获取刷题科目
export function doQuestionBankDetail(data) {
  return request({
    url: 'user/doQuestionBankDetail',
    method: 'get',
    params:data,
  })
}

//获取题目
export function getQuestionList(data) {
  return request({
    url: '/user/getQuestionList',
    method: 'post',
    data,
  })
}

//获取题目位置
export function getQuestionOffset(data) {
  return request({
    url: 'user/getQuestionOffset',
    method: 'get',
    params:data,
  })
}

//记录题目位置
export function doSaveQuestionOffset(data) {
  return request({
    url: '/user/doSaveQuestionOffset',
    method: 'post',
    data,
  })
}

//获取模拟考试
export function toMockExamQuiz(data) {
  return request({
    url: '/user/toMockExamQuiz',
    method: 'post',
    data,
  })
}

//获取错题库
export function getMistakes(data) {
  return request({
    url: '/user/getMistakes',
    method: 'get',
    params:data,
  })
}

//删除错题
export function delMistakes(data) {
  return request({
    url: 'user/delMistakes',
    method: 'post',
    data,
  })
}

//清空错题

export function delUserMistakes(data) {
  return request({
    url: 'user/delUserMistakes.do',
    method: 'post',
    data,
  })
}

//截申请表
export function shanxiHealthScreenshot(data) {
  return request({
    url: 'order/shanxiHealthScreenshot.html',
    method: 'post',
    data,
  })
}
//线上线下截图
export function trainingHoursCertificateInfo(data) {
  return request({
    url: 'trainStudent/trainingHoursCertificateInfo.html',
    method: 'post',
    data,
  })
}

//题库记录题目
export function recordPracticeMistake(data) {
  return request({
    url: 'user/recordPracticeMistake',
    method: 'post',
    data,
  })
}

